module.exports = __webpack_public_path__ + "static/media/bg.5c6a177d.png";


//////////////////
// WEBPACK FOOTER
// ./src/yysChargingOperator/share/images/bg.png
// module id = 1219
// module chunks = 0